// @generated by c1gen-ts
// tslint:disable

export const FeatureFlagIdAccessConflictTriggers = 'ACCESS_CONFLICT_TRIGGERS'
export const FeatureFlagIdAccessConflicts = 'ACCESS_CONFLICTS'
export const FeatureFlagIdAccessEntitlementBindingWithTicket = 'ACCESS_ENTITLEMENT_BINDING_WITH_TICKET'
export const FeatureFlagIdAccessExplorer = 'ACCESS_EXPLORER'
export const FeatureFlagIdAccessRequest = 'ACCESS_REQUEST'
export const FeatureFlagIdAccessReviewOptimizations = 'ACCESS_REVIEW_OPTIMIZATIONS'
export const FeatureFlagIdAccessReviewPgTriggerConsumer = 'ACCESS_REVIEW_PG_TRIGGER_CONSUMER'
export const FeatureFlagIdAccessReviewTemplate = 'ACCESS_REVIEW_TEMPLATE'
export const FeatureFlagIdAccessReviewTypeAccessConflicts = 'ACCESS_REVIEW_TYPE_ACCESS_CONFLICTS'
export const FeatureFlagIdAccessReviewsESignature = 'ACCESS_REVIEWS_E_SIGNATURE'
export const FeatureFlagIdAccountProvisioning = 'ACCOUNT_PROVISIONING'
export const FeatureFlagIdActionTicketType = 'ACTION_TICKET_TYPE'
export const FeatureFlagIdAdditionalEmailsDirectoryMerge = 'ADDITIONAL_EMAILS_DIRECTORY_MERGE'
export const FeatureFlagIdAdditionalEmailsUplift = 'ADDITIONAL_EMAILS_UPLIFT'
export const FeatureFlagIdAgentConversations = 'AGENT_CONVERSATIONS'
export const FeatureFlagIdAiTicketing = 'AI_TICKETING'
export const FeatureFlagIdAiTicketingRecordAppFromCustomField = 'AI_TICKETING_RECORD_APP_FROM_CUSTOM_FIELD'
export const FeatureFlagIdAiTicketingSyncCatalogEmbeddings = 'AI_TICKETING_SYNC_CATALOG_EMBEDDINGS'
export const FeatureFlagIdAllowListForProfileAttributes = 'ALLOW_LIST_FOR_PROFILE_ATTRIBUTES'
export const FeatureFlagIdAllowRetiredConnectors = 'ALLOW_RETIRED_CONNECTORS'
export const FeatureFlagIdAllowShortSyncIntervals = 'ALLOW_SHORT_SYNC_INTERVALS'
export const FeatureFlagIdAnalysis = 'ANALYSIS'
export const FeatureFlagIdAnalysisInsightsForRequests = 'ANALYSIS_INSIGHTS_FOR_REQUESTS'
export const FeatureFlagIdAppAccessRequestDefaults = 'APP_ACCESS_REQUEST_DEFAULTS'
export const FeatureFlagIdAppCatalogs = 'APP_CATALOGS'
export const FeatureFlagIdAppCentricViewAccessReview = 'APP_CENTRIC_VIEW_ACCESS_REVIEW'
export const FeatureFlagIdAppDetails2025Redesign = 'APP_DETAILS_2025_REDESIGN'
export const FeatureFlagIdAppReports = 'APP_REPORTS'
export const FeatureFlagIdAppResourceOwnerManage = 'APP_RESOURCE_OWNER_MANAGE'
export const FeatureFlagIdAppResourceOwnershipRead = 'APP_RESOURCE_OWNERSHIP_READ'
export const FeatureFlagIdAppResourceOwnershipWriteOnly = 'APP_RESOURCE_OWNERSHIP_WRITE_ONLY'
export const FeatureFlagIdAppUserLookupBindings = 'APP_USER_LOOKUP_BINDINGS'
export const FeatureFlagIdAppUsersProcessButton = 'APP_USERS_PROCESS_BUTTON'
export const FeatureFlagIdAuthzOnUserProfiles = 'AUTHZ_ON_USER_PROFILES'
export const FeatureFlagIdAutomationAppScope = 'AUTOMATION_APP_SCOPE'
export const FeatureFlagIdAutomationDebugSteps = 'AUTOMATION_DEBUG_STEPS'
export const FeatureFlagIdAutomationExecutionRateLimit = 'AUTOMATION_EXECUTION_RATE_LIMIT'
export const FeatureFlagIdAutomationRevokeStepEnhanced = 'AUTOMATION_REVOKE_STEP_ENHANCED'
export const FeatureFlagIdAutomationSecretsSteps = 'AUTOMATION_SECRETS_STEPS'
export const FeatureFlagIdAutomationsGrantDiscoveredTrigger = 'AUTOMATIONS_GRANT_DISCOVERED_TRIGGER'
export const FeatureFlagIdAutomationsScheduleTrigger = 'AUTOMATIONS_SCHEDULE_TRIGGER'
export const FeatureFlagIdAwsConnectorSsoScim = 'AWS_CONNECTOR_SSO_SCIM'
export const FeatureFlagIdBatonActionSchemaV2 = 'BATON_ACTION_SCHEMA_V2'
export const FeatureFlagIdBatonFeedConsumer = 'BATON_FEED_CONSUMER'
export const FeatureFlagIdBillingDashboard = 'BILLING_DASHBOARD'
export const FeatureFlagIdBillingEvents = 'BILLING_EVENTS'
export const FeatureFlagIdBranding = 'BRANDING'
export const FeatureFlagIdBrowseAccess2025Redesign = 'BROWSE_ACCESS_2025_REDESIGN'
export const FeatureFlagIdBrowserExtension = 'BROWSER_EXTENSION'
export const FeatureFlagIdBulkActionsV2 = 'BULK_ACTIONS_V2'
export const FeatureFlagIdBulkActionsV2Preview = 'BULK_ACTIONS_V2_PREVIEW'
export const FeatureFlagIdBulkRevocation = 'BULK_REVOCATION'
export const FeatureFlagIdBundleAutomationCircuitBreaker = 'BUNDLE_AUTOMATION_CIRCUIT_BREAKER'
export const FeatureFlagIdBundleAutomationEmergencyShutoff = 'BUNDLE_AUTOMATION_EMERGENCY_SHUTOFF'
export const FeatureFlagIdBypassMatchingEtagSyncCheck = 'BYPASS_MATCHING_ETAG_SYNC_CHECK'
export const FeatureFlagIdCampaignAccuracy = 'CAMPAIGN_ACCURACY'
export const FeatureFlagIdCampaignAutoGenerateReport = 'CAMPAIGN_AUTO_GENERATE_REPORT'
export const FeatureFlagIdCampaignAutoSchedule = 'CAMPAIGN_AUTO_SCHEDULE'
export const FeatureFlagIdCampaignCelExpressionScope = 'CAMPAIGN_CEL_EXPRESSION_SCOPE'
export const FeatureFlagIdCampaignGrantScoping = 'CAMPAIGN_GRANT_SCOPING'
export const FeatureFlagIdCampaignProgressInList = 'CAMPAIGN_PROGRESS_IN_LIST'
export const FeatureFlagIdCampaignScoping = 'CAMPAIGN_SCOPING'
export const FeatureFlagIdCampaignScopingReviewByResourceType = 'CAMPAIGN_SCOPING_REVIEW_BY_RESOURCE_TYPE'
export const FeatureFlagIdCampaignScopingV2 = 'CAMPAIGN_SCOPING_V2'
export const FeatureFlagIdCampaignSlackComms = 'CAMPAIGN_SLACK_COMMS'
export const FeatureFlagIdCascadeDelete = 'CASCADE_DELETE'
export const FeatureFlagIdCatalogRequestBundles = 'CATALOG_REQUEST_BUNDLES'
export const FeatureFlagIdCertifyTaskAutomaticRevocations = 'CERTIFY_TASK_AUTOMATIC_REVOCATIONS'
export const FeatureFlagIdConfluenceReducedSpaceSync = 'CONFLUENCE_REDUCED_SPACE_SYNC'
export const FeatureFlagIdConnectorAccessReviewTasksSearch = 'CONNECTOR_ACCESS_REVIEW_TASKS_SEARCH'
export const FeatureFlagIdConnectorDatadog = 'CONNECTOR_DATADOG'
export const FeatureFlagIdConnectorLambdaDeployments = 'CONNECTOR_LAMBDA_DEPLOYMENTS'
export const FeatureFlagIdConnectorOktaChildAwsApps = 'CONNECTOR_OKTA_CHILD_AWS_APPS'
export const FeatureFlagIdConnectorRamp = 'CONNECTOR_RAMP'
export const FeatureFlagIdConnectorSendgrid = 'CONNECTOR_SENDGRID'
export const FeatureFlagIdConnectorServicenow = 'CONNECTOR_SERVICENOW'
export const FeatureFlagIdConnectorSourcedResourceOwnership = 'CONNECTOR_SOURCED_RESOURCE_OWNERSHIP'
export const FeatureFlagIdConnectorTableau = 'CONNECTOR_TABLEAU'
export const FeatureFlagIdConnectorTransformers = 'CONNECTOR_TRANSFORMERS'
export const FeatureFlagIdConnectorWriteWorkflowV2 = 'CONNECTOR_WRITE_WORKFLOW_V2'
export const FeatureFlagIdConnectorZendesk = 'CONNECTOR_ZENDESK'
export const FeatureFlagIdConnectorsDevManual = 'CONNECTORS_DEV_MANUAL'
export const FeatureFlagIdCopilotAgents = 'COPILOT_AGENTS'
export const FeatureFlagIdCopilotAgentsServiceDesk = 'COPILOT_AGENTS_SERVICE_DESK'
export const FeatureFlagIdCopilotAgentsUserPresence = 'COPILOT_AGENTS_USER_PRESENCE'
export const FeatureFlagIdCopilotAutomationAgent = 'COPILOT_AUTOMATION_AGENT'
export const FeatureFlagIdCopilotCelEditor = 'COPILOT_CEL_EDITOR'
export const FeatureFlagIdCopilotClustering = 'COPILOT_CLUSTERING'
export const FeatureFlagIdCopilotInsights = 'COPILOT_INSIGHTS'
export const FeatureFlagIdCopilotServiceDeskUniversalEmbeddings = 'COPILOT_SERVICE_DESK_UNIVERSAL_EMBEDDINGS'
export const FeatureFlagIdCopilotThomas = 'COPILOT_THOMAS'
export const FeatureFlagIdCopilotUi = 'COPILOT_UI'
export const FeatureFlagIdCreateApp2025Redesign = 'CREATE_APP_2025_REDESIGN'
export const FeatureFlagIdCustomDurationSelect = 'CUSTOM_DURATION_SELECT'
export const FeatureFlagIdDailyDigestAndNotifications = 'DAILY_DIGEST_AND_NOTIFICATIONS'
export const FeatureFlagIdDailyDigestDeactivatedUserSection = 'DAILY_DIGEST_DEACTIVATED_USER_SECTION'
export const FeatureFlagIdDailyDigestV2 = 'DAILY_DIGEST_V2'
export const FeatureFlagIdDarkMode = 'DARK_MODE'
export const FeatureFlagIdDashboardSecurity = 'DASHBOARD_SECURITY'
export const FeatureFlagIdDatasources = 'DATASOURCES'
export const FeatureFlagIdDebugLogging = 'DEBUG_LOGGING'
export const FeatureFlagIdDedupeAppUpliftQueue = 'DEDUPE_APP_UPLIFT_QUEUE'
export const FeatureFlagIdDeprovisionerPolicy = 'DEPROVISIONER_POLICY'
export const FeatureFlagIdDestinationEntitlementsTriggerOnChange = 'DESTINATION_ENTITLEMENTS_TRIGGER_ON_CHANGE'
export const FeatureFlagIdDirectoryManagerMappingV2 = 'DIRECTORY_MANAGER_MAPPING_V2'
export const FeatureFlagIdDirectoryPush = 'DIRECTORY_PUSH'
export const FeatureFlagIdDisableAllAutomations = 'DISABLE_ALL_AUTOMATIONS'
export const FeatureFlagIdDisableBrowseAppCounts = 'DISABLE_BROWSE_APP_COUNTS'
export const FeatureFlagIdDisableBundleCreateRequests = 'DISABLE_BUNDLE_CREATE_REQUESTS'
export const FeatureFlagIdDisableDirectoryMerge = 'DISABLE_DIRECTORY_MERGE'
export const FeatureFlagIdDisableGrantCounts = 'DISABLE_GRANT_COUNTS'
export const FeatureFlagIdDisableIncrementalSync = 'DISABLE_INCREMENTAL_SYNC'
export const FeatureFlagIdDisableSystemProxyEntitlementsButton = 'DISABLE_SYSTEM_PROXY_ENTITLEMENTS_BUTTON'
export const FeatureFlagIdDisableTaskAssignedToFilter = 'DISABLE_TASK_ASSIGNED_TO_FILTER'
export const FeatureFlagIdDisableUsageSyncV1 = 'DISABLE_USAGE_SYNC_V1'
export const FeatureFlagIdDisableUsageV1 = 'DISABLE_USAGE_V1'
export const FeatureFlagIdDisableUserStatusAuthzCheck = 'DISABLE_USER_STATUS_AUTHZ_CHECK'
export const FeatureFlagIdDpopBrowserSessions = 'DPOP_BROWSER_SESSIONS'
export const FeatureFlagIdDualWrite = 'DUAL_WRITE'
export const FeatureFlagIdEmailNotificationsV2 = 'EMAIL_NOTIFICATIONS_V2'
export const FeatureFlagIdEmailTemplatesV2 = 'EMAIL_TEMPLATES_V2'
export const FeatureFlagIdEmergencyAccess = 'EMERGENCY_ACCESS'
export const FeatureFlagIdEmergencyNotificationShutoff = 'EMERGENCY_NOTIFICATION_SHUTOFF'
export const FeatureFlagIdEnableLambdaConnectorsOnCreation = 'ENABLE_LAMBDA_CONNECTORS_ON_CREATION'
export const FeatureFlagIdEnableTaskTableSort = 'ENABLE_TASK_TABLE_SORT'
export const FeatureFlagIdEnableTemporalWorkflowConfigs = 'ENABLE_TEMPORAL_WORKFLOW_CONFIGS'
export const FeatureFlagIdEntitlementResourceTypeCopyDataQuery = 'ENTITLEMENT_RESOURCE_TYPE_COPY_DATA_QUERY'
export const FeatureFlagIdEntitlementSearchHedgedFacets = 'ENTITLEMENT_SEARCH_HEDGED_FACETS'
export const FeatureFlagIdEntitlementsPageV2 = 'ENTITLEMENTS_PAGE_V2'
export const FeatureFlagIdEntraMailboxOptions = 'ENTRA_MAILBOX_OPTIONS'
export const FeatureFlagIdEventStreamer = 'EVENT_STREAMER'
export const FeatureFlagIdExpiringAccessSlackAndSchedule = 'EXPIRING_ACCESS_SLACK_AND_SCHEDULE'
export const FeatureFlagIdExpiringDelegatedUsers = 'EXPIRING_DELEGATED_USERS'
export const FeatureFlagIdExploreSearchV2 = 'EXPLORE_SEARCH_V2'
export const FeatureFlagIdExportData = 'EXPORT_DATA'
export const FeatureFlagIdExternalTicketing = 'EXTERNAL_TICKETING'
export const FeatureFlagIdExternalTicketingBulkTasks = 'EXTERNAL_TICKETING_BULK_TASKS'
export const FeatureFlagIdFeatureFlagIdAiTicketingZohoManageEngine = 'FEATURE_FLAG_ID_AI_TICKETING_ZOHO_MANAGE_ENGINE'
export const FeatureFlagIdFirstSyncSkipEntitlementsAndGrants = 'FIRST_SYNC_SKIP_ENTITLEMENTS_AND_GRANTS'
export const FeatureFlagIdFixUpliftAeubResourceCache = 'FIX_UPLIFT_AEUB_RESOURCE_CACHE'
export const FeatureFlagIdFunctions = 'FUNCTIONS'
export const FeatureFlagIdGenerateUniqueAccountNameStep = 'GENERATE_UNIQUE_ACCOUNT_NAME_STEP'
export const FeatureFlagIdGovernorWakeExpiringGrants = 'GOVERNOR_WAKE_EXPIRING_GRANTS'
export const FeatureFlagIdGrantDestinations = 'GRANT_DESTINATIONS'
export const FeatureFlagIdGrantReasons = 'GRANT_REASONS'
export const FeatureFlagIdGrantReasonsManualMembership = 'GRANT_REASONS_MANUAL_MEMBERSHIP'
export const FeatureFlagIdGrantSources = 'GRANT_SOURCES'
export const FeatureFlagIdGrantTriggerEntitlementFilterV2 = 'GRANT_TRIGGER_ENTITLEMENT_FILTER_V2'
export const FeatureFlagIdGuidanceBanners = 'GUIDANCE_BANNERS'
export const FeatureFlagIdHideC1UserExtendedProfileViaPolicy = 'HIDE_C1_USER_EXTENDED_PROFILE_VIA_POLICY'
export const FeatureFlagIdIncreaseConnectorV2PageSize = 'INCREASE_CONNECTOR_V2_PAGE_SIZE'
export const FeatureFlagIdIncreaseDefaultPageSize = 'INCREASE_DEFAULT_PAGE_SIZE'
export const FeatureFlagIdIncrementalGrants = 'INCREMENTAL_GRANTS'
export const FeatureFlagIdIncrementalRevocations = 'INCREMENTAL_REVOCATIONS'
export const FeatureFlagIdIngressRateLimits = 'INGRESS_RATE_LIMITS'
export const FeatureFlagIdInventory = 'INVENTORY'
export const FeatureFlagIdInventoryAlerts = 'INVENTORY_ALERTS'
export const FeatureFlagIdJitCreateAppUsersInGrantTickets = 'JIT_CREATE_APP_USERS_IN_GRANT_TICKETS'
export const FeatureFlagIdJitterUsage = 'JITTER_USAGE'
export const FeatureFlagIdJml = 'JML'
export const FeatureFlagIdLeavers = 'LEAVERS'
export const FeatureFlagIdLightweightApiViewsBeta = 'LIGHTWEIGHT_API_VIEWS_BETA'
export const FeatureFlagIdLightweightApiViewsStable = 'LIGHTWEIGHT_API_VIEWS_STABLE'
export const FeatureFlagIdLightweightC1UserApiViews = 'LIGHTWEIGHT_C1_USER_API_VIEWS'
export const FeatureFlagIdLinkedEntitlements = 'LINKED_ENTITLEMENTS'
export const FeatureFlagIdMagicLinkDelivery = 'MAGIC_LINK_DELIVERY'
export const FeatureFlagIdManuallyManageUiButton = 'MANUALLY_MANAGE_UI_BUTTON'
export const FeatureFlagIdMarkEventsConsumed = 'MARK_EVENTS_CONSUMED'
export const FeatureFlagIdMatchBatonIdAntichurn = 'MATCH_BATON_ID_ANTICHURN'
export const FeatureFlagIdMatchEmailWithPlus = 'MATCH_EMAIL_WITH_PLUS'
export const FeatureFlagIdMetricModels = 'METRIC_MODELS'
export const FeatureFlagIdMigrationDryRun = 'MIGRATION_DRY_RUN'
export const FeatureFlagIdMsTeams = 'MS_TEAMS'
export const FeatureFlagIdMsTeamsCampaignMessages = 'MS_TEAMS_CAMPAIGN_MESSAGES'
export const FeatureFlagIdMultiAccessRequest = 'MULTI_ACCESS_REQUEST'
export const FeatureFlagIdNewConnectorValidation = 'NEW_CONNECTOR_VALIDATION'
export const FeatureFlagIdNewNav2026 = 'NEW_NAV_2026'
export const FeatureFlagIdNewSearchEntitlementsEndpoint = 'NEW_SEARCH_ENTITLEMENTS_ENDPOINT'
export const FeatureFlagIdNonDirectoryUserAttributes = 'NON_DIRECTORY_USER_ATTRIBUTES'
export const FeatureFlagIdNotificationsV2 = 'NOTIFICATIONS_V2'
export const FeatureFlagIdOauth2Dcr = 'OAUTH2_DCR'
export const FeatureFlagIdOauth2PersonalClients = 'OAUTH2_PERSONAL_CLIENTS'
export const FeatureFlagIdOffboarding = 'OFFBOARDING'
export const FeatureFlagIdOktaDontSyncInactiveApps = 'OKTA_DONT_SYNC_INACTIVE_APPS'
export const FeatureFlagIdOptimizedAccessReviewEntitlementSearch = 'OPTIMIZED_ACCESS_REVIEW_ENTITLEMENT_SEARCH'
export const FeatureFlagIdPasswordPush = 'PASSWORD_PUSH'
export const FeatureFlagIdPasswordReplication = 'PASSWORD_REPLICATION'
export const FeatureFlagIdPgHedge = 'PG_HEDGE'
export const FeatureFlagIdPgRuntimeSettings = 'PG_RUNTIME_SETTINGS'
export const FeatureFlagIdPgv2AppSearch = 'PGV2_APP_SEARCH'
export const FeatureFlagIdPgv2EngWeekQueryUpgrades = 'PGV2_ENG_WEEK_QUERY_UPGRADES'
export const FeatureFlagIdPolicyEngineInContext = 'POLICY_ENGINE_IN_CONTEXT'
export const FeatureFlagIdPolicyStepExpressions = 'POLICY_STEP_EXPRESSIONS'
export const FeatureFlagIdProcessApprovalCheckPreviousStepsInWaitStep = 'PROCESS_APPROVAL_CHECK_PREVIOUS_STEPS_IN_WAIT_STEP'
export const FeatureFlagIdProfiles2025Redesign = 'PROFILES_2025_REDESIGN'
export const FeatureFlagIdProvisioningDrawer = 'PROVISIONING_DRAWER'
export const FeatureFlagIdProvisioningLocksDoNotAcquireNextStepLocks = 'PROVISIONING_LOCKS_DO_NOT_ACQUIRE_NEXT_STEP_LOCKS'
export const FeatureFlagIdRedisRateLimits = 'REDIS_RATE_LIMITS'
export const FeatureFlagIdReopenAccessReview = 'REOPEN_ACCESS_REVIEW'
export const FeatureFlagIdRequestSchema = 'REQUEST_SCHEMA'
export const FeatureFlagIdRequestSchemaSecrets = 'REQUEST_SCHEMA_SECRETS'
export const FeatureFlagIdRequestableAutomations = 'REQUESTABLE_AUTOMATIONS'
export const FeatureFlagIdRequireDistinctApproversUi = 'REQUIRE_DISTINCT_APPROVERS_UI'
export const FeatureFlagIdResourceActionGroupUi = 'RESOURCE_ACTION_GROUP_UI'
export const FeatureFlagIdResourceActions = 'RESOURCE_ACTIONS'
export const FeatureFlagIdResourceTypeSelectiveSync = 'RESOURCE_TYPE_SELECTIVE_SYNC'
export const FeatureFlagIdRestartErroredProvisionTasks = 'RESTART_ERRORED_PROVISION_TASKS'
export const FeatureFlagIdResurrectAppEntitlements = 'RESURRECT_APP_ENTITLEMENTS'
export const FeatureFlagIdResurrectAppResourceTypes = 'RESURRECT_APP_RESOURCE_TYPES'
export const FeatureFlagIdResurrectAppResources = 'RESURRECT_APP_RESOURCES'
export const FeatureFlagIdReverseLookupBindings = 'REVERSE_LOOKUP_BINDINGS'
export const FeatureFlagIdReviewSkipAccessProfiles = 'REVIEW_SKIP_ACCESS_PROFILES'
export const FeatureFlagIdReviewsPendingActions = 'REVIEWS_PENDING_ACTIONS'
export const FeatureFlagIdRoleMiningSimilarity = 'ROLE_MINING_SIMILARITY'
export const FeatureFlagIdRoleMiningSimilarityUx = 'ROLE_MINING_SIMILARITY_UX'
export const FeatureFlagIdSecurityInsights = 'SECURITY_INSIGHTS'
export const FeatureFlagIdSendReminder = 'SEND_REMINDER'
export const FeatureFlagIdServiceModeSkipGrantExpansion = 'SERVICE_MODE_SKIP_GRANT_EXPANSION'
export const FeatureFlagIdShowProfileToEndUsers = 'SHOW_PROFILE_TO_END_USERS'
export const FeatureFlagIdSkipTicketWaitingForIdentityTrigger = 'SKIP_TICKET_WAITING_FOR_IDENTITY_TRIGGER'
export const FeatureFlagIdSlaEscalationPolicy = 'SLA_ESCALATION_POLICY'
export const FeatureFlagIdSlackFeaturesV2 = 'SLACK_FEATURES_V2'
export const FeatureFlagIdSlackNotificationsV2 = 'SLACK_NOTIFICATIONS_V2'
export const FeatureFlagIdSlackSlashCommand = 'SLACK_SLASH_COMMAND'
export const FeatureFlagIdSortByAccountOwner = 'SORT_BY_ACCOUNT_OWNER'
export const FeatureFlagIdSplitExternalAppUsersInUplift = 'SPLIT_EXTERNAL_APP_USERS_IN_UPLIFT'
export const FeatureFlagIdSpotlight = 'SPOTLIGHT'
export const FeatureFlagIdStepUpAuth = 'STEP_UP_AUTH'
export const FeatureFlagIdSuperDirectory = 'SUPER_DIRECTORY'
export const FeatureFlagIdSuperDirectoryAccountFilter = 'SUPER_DIRECTORY_ACCOUNT_FILTER'
export const FeatureFlagIdSuperDirectorySkuQuotaLimit = 'SUPER_DIRECTORY_SKU_QUOTA_LIMIT'
export const FeatureFlagIdSuperDirectoryUserAttributePush = 'SUPER_DIRECTORY_USER_ATTRIBUTE_PUSH'
export const FeatureFlagIdSyncFetchRateLimiting = 'SYNC_FETCH_RATE_LIMITING'
export const FeatureFlagIdSyncIntervalConfiguration = 'SYNC_INTERVAL_CONFIGURATION'
export const FeatureFlagIdSyncMultiTraitedResources = 'SYNC_MULTI_TRAITED_RESOURCES'
export const FeatureFlagIdSystemManagement = 'SYSTEM_MANAGEMENT'
export const FeatureFlagIdTicketCommentCount = 'TICKET_COMMENT_COUNT'
export const FeatureFlagIdTicketCounterIdAssign = 'TICKET_COUNTER_ID_ASSIGN'
export const FeatureFlagIdTicketCounterIdVisible = 'TICKET_COUNTER_ID_VISIBLE'
export const FeatureFlagIdTicketFiltersHedge = 'TICKET_FILTERS_HEDGE'
export const FeatureFlagIdTicketNotificationsV2 = 'TICKET_NOTIFICATIONS_V2'
export const FeatureFlagIdTicketProvisioningLock = 'TICKET_PROVISIONING_LOCK'
export const FeatureFlagIdTicketProvisioningLocksEarlyRelease = 'TICKET_PROVISIONING_LOCKS_EARLY_RELEASE'
export const FeatureFlagIdTimeBasedAccessProfileRequests = 'TIME_BASED_ACCESS_PROFILE_REQUESTS'
export const FeatureFlagIdTsdbGaugeWorkflowShutoff = 'TSDB_GAUGE_WORKFLOW_SHUTOFF'
export const FeatureFlagIdTsdbMetrics = 'TSDB_METRICS'
export const FeatureFlagIdTsdbMetricsDashboards = 'TSDB_METRICS_DASHBOARDS'
export const FeatureFlagIdTsdbMetricsDashboardsPreview = 'TSDB_METRICS_DASHBOARDS_PREVIEW'
export const FeatureFlagIdUniversalEmbeddings = 'UNIVERSAL_EMBEDDINGS'
export const FeatureFlagIdUpliftByApp = 'UPLIFT_BY_APP'
export const FeatureFlagIdUpliftFullAction = 'UPLIFT_FULL_ACTION'
export const FeatureFlagIdUpliftLifecycleTracking = 'UPLIFT_LIFECYCLE_TRACKING'
export const FeatureFlagIdUpliftStatusProcessingChip = 'UPLIFT_STATUS_PROCESSING_CHIP'
export const FeatureFlagIdUsageBasedRevocations = 'USAGE_BASED_REVOCATIONS'
export const FeatureFlagIdUseTemporalCloud = 'USE_TEMPORAL_CLOUD'
export const FeatureFlagIdUserAddedMcpTools = 'USER_ADDED_MCP_TOOLS'
export const FeatureFlagIdUserAttributes = 'USER_ATTRIBUTES'
export const FeatureFlagIdUserMergeFavorEnabledSources = 'USER_MERGE_FAVOR_ENABLED_SOURCES'
export const FeatureFlagIdUsernameUplift = 'USERNAME_UPLIFT'
export const FeatureFlagIdVerboseScanShardedDebug = 'VERBOSE_SCAN_SHARDED_DEBUG'
export const FeatureFlagIdWebhookApprovals = 'WEBHOOK_APPROVALS'
export const FeatureFlagIdWebhooks = 'WEBHOOKS'
export const FeatureFlagIdWebsocketNotify = 'WEBSOCKET_NOTIFY'
export const FeatureFlagIdWorkflowAutomationEmergencyShutoff = 'WORKFLOW_AUTOMATION_EMERGENCY_SHUTOFF'
export const FeatureFlagIdWorkflowsFeatureV2 = 'WORKFLOWS_FEATURE_V2'
export const FeatureFlagIdYearInReview2025 = 'YEAR_IN_REVIEW_2025'

export type Features = 
  'ACCESS_CONFLICT_TRIGGERS'
  | 'ACCESS_CONFLICTS'
  | 'ACCESS_ENTITLEMENT_BINDING_WITH_TICKET'
  | 'ACCESS_EXPLORER'
  | 'ACCESS_REQUEST'
  | 'ACCESS_REVIEW_OPTIMIZATIONS'
  | 'ACCESS_REVIEW_PG_TRIGGER_CONSUMER'
  | 'ACCESS_REVIEW_TEMPLATE'
  | 'ACCESS_REVIEW_TYPE_ACCESS_CONFLICTS'
  | 'ACCESS_REVIEWS_E_SIGNATURE'
  | 'ACCOUNT_PROVISIONING'
  | 'ACTION_TICKET_TYPE'
  | 'ADDITIONAL_EMAILS_DIRECTORY_MERGE'
  | 'ADDITIONAL_EMAILS_UPLIFT'
  | 'AGENT_CONVERSATIONS'
  | 'AI_TICKETING'
  | 'AI_TICKETING_RECORD_APP_FROM_CUSTOM_FIELD'
  | 'AI_TICKETING_SYNC_CATALOG_EMBEDDINGS'
  | 'ALLOW_LIST_FOR_PROFILE_ATTRIBUTES'
  | 'ALLOW_RETIRED_CONNECTORS'
  | 'ALLOW_SHORT_SYNC_INTERVALS'
  | 'ANALYSIS'
  | 'ANALYSIS_INSIGHTS_FOR_REQUESTS'
  | 'APP_ACCESS_REQUEST_DEFAULTS'
  | 'APP_CATALOGS'
  | 'APP_CENTRIC_VIEW_ACCESS_REVIEW'
  | 'APP_DETAILS_2025_REDESIGN'
  | 'APP_REPORTS'
  | 'APP_RESOURCE_OWNER_MANAGE'
  | 'APP_RESOURCE_OWNERSHIP_READ'
  | 'APP_RESOURCE_OWNERSHIP_WRITE_ONLY'
  | 'APP_USER_LOOKUP_BINDINGS'
  | 'APP_USERS_PROCESS_BUTTON'
  | 'AUTHZ_ON_USER_PROFILES'
  | 'AUTOMATION_APP_SCOPE'
  | 'AUTOMATION_DEBUG_STEPS'
  | 'AUTOMATION_EXECUTION_RATE_LIMIT'
  | 'AUTOMATION_REVOKE_STEP_ENHANCED'
  | 'AUTOMATION_SECRETS_STEPS'
  | 'AUTOMATIONS_GRANT_DISCOVERED_TRIGGER'
  | 'AUTOMATIONS_SCHEDULE_TRIGGER'
  | 'AWS_CONNECTOR_SSO_SCIM'
  | 'BATON_ACTION_SCHEMA_V2'
  | 'BATON_FEED_CONSUMER'
  | 'BILLING_DASHBOARD'
  | 'BILLING_EVENTS'
  | 'BRANDING'
  | 'BROWSE_ACCESS_2025_REDESIGN'
  | 'BROWSER_EXTENSION'
  | 'BULK_ACTIONS_V2'
  | 'BULK_ACTIONS_V2_PREVIEW'
  | 'BULK_REVOCATION'
  | 'BUNDLE_AUTOMATION_CIRCUIT_BREAKER'
  | 'BUNDLE_AUTOMATION_EMERGENCY_SHUTOFF'
  | 'BYPASS_MATCHING_ETAG_SYNC_CHECK'
  | 'CAMPAIGN_ACCURACY'
  | 'CAMPAIGN_AUTO_GENERATE_REPORT'
  | 'CAMPAIGN_AUTO_SCHEDULE'
  | 'CAMPAIGN_CEL_EXPRESSION_SCOPE'
  | 'CAMPAIGN_GRANT_SCOPING'
  | 'CAMPAIGN_PROGRESS_IN_LIST'
  | 'CAMPAIGN_SCOPING'
  | 'CAMPAIGN_SCOPING_REVIEW_BY_RESOURCE_TYPE'
  | 'CAMPAIGN_SCOPING_V2'
  | 'CAMPAIGN_SLACK_COMMS'
  | 'CASCADE_DELETE'
  | 'CATALOG_REQUEST_BUNDLES'
  | 'CERTIFY_TASK_AUTOMATIC_REVOCATIONS'
  | 'CONFLUENCE_REDUCED_SPACE_SYNC'
  | 'CONNECTOR_ACCESS_REVIEW_TASKS_SEARCH'
  | 'CONNECTOR_DATADOG'
  | 'CONNECTOR_LAMBDA_DEPLOYMENTS'
  | 'CONNECTOR_OKTA_CHILD_AWS_APPS'
  | 'CONNECTOR_RAMP'
  | 'CONNECTOR_SENDGRID'
  | 'CONNECTOR_SERVICENOW'
  | 'CONNECTOR_SOURCED_RESOURCE_OWNERSHIP'
  | 'CONNECTOR_TABLEAU'
  | 'CONNECTOR_TRANSFORMERS'
  | 'CONNECTOR_WRITE_WORKFLOW_V2'
  | 'CONNECTOR_ZENDESK'
  | 'CONNECTORS_DEV_MANUAL'
  | 'COPILOT_AGENTS'
  | 'COPILOT_AGENTS_SERVICE_DESK'
  | 'COPILOT_AGENTS_USER_PRESENCE'
  | 'COPILOT_AUTOMATION_AGENT'
  | 'COPILOT_CEL_EDITOR'
  | 'COPILOT_CLUSTERING'
  | 'COPILOT_INSIGHTS'
  | 'COPILOT_SERVICE_DESK_UNIVERSAL_EMBEDDINGS'
  | 'COPILOT_THOMAS'
  | 'COPILOT_UI'
  | 'CREATE_APP_2025_REDESIGN'
  | 'CUSTOM_DURATION_SELECT'
  | 'DAILY_DIGEST_AND_NOTIFICATIONS'
  | 'DAILY_DIGEST_DEACTIVATED_USER_SECTION'
  | 'DAILY_DIGEST_V2'
  | 'DARK_MODE'
  | 'DASHBOARD_SECURITY'
  | 'DATASOURCES'
  | 'DEBUG_LOGGING'
  | 'DEDUPE_APP_UPLIFT_QUEUE'
  | 'DEPROVISIONER_POLICY'
  | 'DESTINATION_ENTITLEMENTS_TRIGGER_ON_CHANGE'
  | 'DIRECTORY_MANAGER_MAPPING_V2'
  | 'DIRECTORY_PUSH'
  | 'DISABLE_ALL_AUTOMATIONS'
  | 'DISABLE_BROWSE_APP_COUNTS'
  | 'DISABLE_BUNDLE_CREATE_REQUESTS'
  | 'DISABLE_DIRECTORY_MERGE'
  | 'DISABLE_GRANT_COUNTS'
  | 'DISABLE_INCREMENTAL_SYNC'
  | 'DISABLE_SYSTEM_PROXY_ENTITLEMENTS_BUTTON'
  | 'DISABLE_TASK_ASSIGNED_TO_FILTER'
  | 'DISABLE_USAGE_SYNC_V1'
  | 'DISABLE_USAGE_V1'
  | 'DISABLE_USER_STATUS_AUTHZ_CHECK'
  | 'DPOP_BROWSER_SESSIONS'
  | 'DUAL_WRITE'
  | 'EMAIL_NOTIFICATIONS_V2'
  | 'EMAIL_TEMPLATES_V2'
  | 'EMERGENCY_ACCESS'
  | 'EMERGENCY_NOTIFICATION_SHUTOFF'
  | 'ENABLE_LAMBDA_CONNECTORS_ON_CREATION'
  | 'ENABLE_TASK_TABLE_SORT'
  | 'ENABLE_TEMPORAL_WORKFLOW_CONFIGS'
  | 'ENTITLEMENT_RESOURCE_TYPE_COPY_DATA_QUERY'
  | 'ENTITLEMENT_SEARCH_HEDGED_FACETS'
  | 'ENTITLEMENTS_PAGE_V2'
  | 'ENTRA_MAILBOX_OPTIONS'
  | 'EVENT_STREAMER'
  | 'EXPIRING_ACCESS_SLACK_AND_SCHEDULE'
  | 'EXPIRING_DELEGATED_USERS'
  | 'EXPLORE_SEARCH_V2'
  | 'EXPORT_DATA'
  | 'EXTERNAL_TICKETING'
  | 'EXTERNAL_TICKETING_BULK_TASKS'
  | 'FEATURE_FLAG_ID_AI_TICKETING_ZOHO_MANAGE_ENGINE'
  | 'FIRST_SYNC_SKIP_ENTITLEMENTS_AND_GRANTS'
  | 'FIX_UPLIFT_AEUB_RESOURCE_CACHE'
  | 'FUNCTIONS'
  | 'GENERATE_UNIQUE_ACCOUNT_NAME_STEP'
  | 'GOVERNOR_WAKE_EXPIRING_GRANTS'
  | 'GRANT_DESTINATIONS'
  | 'GRANT_REASONS'
  | 'GRANT_REASONS_MANUAL_MEMBERSHIP'
  | 'GRANT_SOURCES'
  | 'GRANT_TRIGGER_ENTITLEMENT_FILTER_V2'
  | 'GUIDANCE_BANNERS'
  | 'HIDE_C1_USER_EXTENDED_PROFILE_VIA_POLICY'
  | 'INCREASE_CONNECTOR_V2_PAGE_SIZE'
  | 'INCREASE_DEFAULT_PAGE_SIZE'
  | 'INCREMENTAL_GRANTS'
  | 'INCREMENTAL_REVOCATIONS'
  | 'INGRESS_RATE_LIMITS'
  | 'INVENTORY'
  | 'INVENTORY_ALERTS'
  | 'JIT_CREATE_APP_USERS_IN_GRANT_TICKETS'
  | 'JITTER_USAGE'
  | 'JML'
  | 'LEAVERS'
  | 'LIGHTWEIGHT_API_VIEWS_BETA'
  | 'LIGHTWEIGHT_API_VIEWS_STABLE'
  | 'LIGHTWEIGHT_C1_USER_API_VIEWS'
  | 'LINKED_ENTITLEMENTS'
  | 'MAGIC_LINK_DELIVERY'
  | 'MANUALLY_MANAGE_UI_BUTTON'
  | 'MARK_EVENTS_CONSUMED'
  | 'MATCH_BATON_ID_ANTICHURN'
  | 'MATCH_EMAIL_WITH_PLUS'
  | 'METRIC_MODELS'
  | 'MIGRATION_DRY_RUN'
  | 'MS_TEAMS'
  | 'MS_TEAMS_CAMPAIGN_MESSAGES'
  | 'MULTI_ACCESS_REQUEST'
  | 'NEW_CONNECTOR_VALIDATION'
  | 'NEW_NAV_2026'
  | 'NEW_SEARCH_ENTITLEMENTS_ENDPOINT'
  | 'NON_DIRECTORY_USER_ATTRIBUTES'
  | 'NOTIFICATIONS_V2'
  | 'OAUTH2_DCR'
  | 'OAUTH2_PERSONAL_CLIENTS'
  | 'OFFBOARDING'
  | 'OKTA_DONT_SYNC_INACTIVE_APPS'
  | 'OPTIMIZED_ACCESS_REVIEW_ENTITLEMENT_SEARCH'
  | 'PASSWORD_PUSH'
  | 'PASSWORD_REPLICATION'
  | 'PG_HEDGE'
  | 'PG_RUNTIME_SETTINGS'
  | 'PGV2_APP_SEARCH'
  | 'PGV2_ENG_WEEK_QUERY_UPGRADES'
  | 'POLICY_ENGINE_IN_CONTEXT'
  | 'POLICY_STEP_EXPRESSIONS'
  | 'PROCESS_APPROVAL_CHECK_PREVIOUS_STEPS_IN_WAIT_STEP'
  | 'PROFILES_2025_REDESIGN'
  | 'PROVISIONING_DRAWER'
  | 'PROVISIONING_LOCKS_DO_NOT_ACQUIRE_NEXT_STEP_LOCKS'
  | 'REDIS_RATE_LIMITS'
  | 'REOPEN_ACCESS_REVIEW'
  | 'REQUEST_SCHEMA'
  | 'REQUEST_SCHEMA_SECRETS'
  | 'REQUESTABLE_AUTOMATIONS'
  | 'REQUIRE_DISTINCT_APPROVERS_UI'
  | 'RESOURCE_ACTION_GROUP_UI'
  | 'RESOURCE_ACTIONS'
  | 'RESOURCE_TYPE_SELECTIVE_SYNC'
  | 'RESTART_ERRORED_PROVISION_TASKS'
  | 'RESURRECT_APP_ENTITLEMENTS'
  | 'RESURRECT_APP_RESOURCE_TYPES'
  | 'RESURRECT_APP_RESOURCES'
  | 'REVERSE_LOOKUP_BINDINGS'
  | 'REVIEW_SKIP_ACCESS_PROFILES'
  | 'REVIEWS_PENDING_ACTIONS'
  | 'ROLE_MINING_SIMILARITY'
  | 'ROLE_MINING_SIMILARITY_UX'
  | 'SECURITY_INSIGHTS'
  | 'SEND_REMINDER'
  | 'SERVICE_MODE_SKIP_GRANT_EXPANSION'
  | 'SHOW_PROFILE_TO_END_USERS'
  | 'SKIP_TICKET_WAITING_FOR_IDENTITY_TRIGGER'
  | 'SLA_ESCALATION_POLICY'
  | 'SLACK_FEATURES_V2'
  | 'SLACK_NOTIFICATIONS_V2'
  | 'SLACK_SLASH_COMMAND'
  | 'SORT_BY_ACCOUNT_OWNER'
  | 'SPLIT_EXTERNAL_APP_USERS_IN_UPLIFT'
  | 'SPOTLIGHT'
  | 'STEP_UP_AUTH'
  | 'SUPER_DIRECTORY'
  | 'SUPER_DIRECTORY_ACCOUNT_FILTER'
  | 'SUPER_DIRECTORY_SKU_QUOTA_LIMIT'
  | 'SUPER_DIRECTORY_USER_ATTRIBUTE_PUSH'
  | 'SYNC_FETCH_RATE_LIMITING'
  | 'SYNC_INTERVAL_CONFIGURATION'
  | 'SYNC_MULTI_TRAITED_RESOURCES'
  | 'SYSTEM_MANAGEMENT'
  | 'TICKET_COMMENT_COUNT'
  | 'TICKET_COUNTER_ID_ASSIGN'
  | 'TICKET_COUNTER_ID_VISIBLE'
  | 'TICKET_FILTERS_HEDGE'
  | 'TICKET_NOTIFICATIONS_V2'
  | 'TICKET_PROVISIONING_LOCK'
  | 'TICKET_PROVISIONING_LOCKS_EARLY_RELEASE'
  | 'TIME_BASED_ACCESS_PROFILE_REQUESTS'
  | 'TSDB_GAUGE_WORKFLOW_SHUTOFF'
  | 'TSDB_METRICS'
  | 'TSDB_METRICS_DASHBOARDS'
  | 'TSDB_METRICS_DASHBOARDS_PREVIEW'
  | 'UNIVERSAL_EMBEDDINGS'
  | 'UPLIFT_BY_APP'
  | 'UPLIFT_FULL_ACTION'
  | 'UPLIFT_LIFECYCLE_TRACKING'
  | 'UPLIFT_STATUS_PROCESSING_CHIP'
  | 'USAGE_BASED_REVOCATIONS'
  | 'USE_TEMPORAL_CLOUD'
  | 'USER_ADDED_MCP_TOOLS'
  | 'USER_ATTRIBUTES'
  | 'USER_MERGE_FAVOR_ENABLED_SOURCES'
  | 'USERNAME_UPLIFT'
  | 'VERBOSE_SCAN_SHARDED_DEBUG'
  | 'WEBHOOK_APPROVALS'
  | 'WEBHOOKS'
  | 'WEBSOCKET_NOTIFY'
  | 'WORKFLOW_AUTOMATION_EMERGENCY_SHUTOFF'
  | 'WORKFLOWS_FEATURE_V2'
  | 'YEAR_IN_REVIEW_2025'
